export default __webpack_public_path__ + "static/media/logo-cs.563b0329.png";